import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const April = () => {
    return (
        <Fragment>{SkipDays(3, 4, [])}</Fragment>  
    )
}